"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constants = require("./constants");

var _default = {
  PropTypes: {
    dataArray: _propTypes.default.arrayOf(_propTypes.default.shape({
      iconUrl: _propTypes.default.string,
      productTile: _propTypes.default.string,
      showSearchWidget: _propTypes.default.string,
      redirectionUrl: _propTypes.default.string
    })),
    headingDesktop: _propTypes.default.string.isRequired,
    headingMobile: _propTypes.default.string.isRequired,
    theme: _propTypes.default.string,
    isMobile: _propTypes.default.bool.isRequired,
    isIE: _propTypes.default.bool,
    tileItemFlexDirection: _propTypes.default.string
  },
  defaultProps: {
    headingDesktop: _constants.TEXT_WEB,
    headingMobile: _constants.TEXT_MOB,
    isMobile: false,
    theme: _constant.DEFAULT_THEME
  }
};
exports.default = _default;